import {
    Button,
    Column,
    Container,
    MaterialContext,
    Row,
    Text,
    ThemeContext,
} from '@wonderlandengine/react-ui/components';
import { Align, Justify, ReactUiBase } from '@wonderlandengine/react-ui';
import React, { useState, useEffect } from 'react';
import { GameFlowController } from '../core/game-flow-controller.js';

function startGame() {
    GameFlowController.instance.startGame();
}

const MainMenuComponent = (props: { comp: MainMenu }) => {
    const isVRSupported = props.comp.engine.vrSupported;
    const [isInVR, setIsInVR] = useState(false);
    useEffect(() => {
        const enterVR = () => setIsInVR(true);
        const exitVR = () => setIsInVR(false);
        props.comp.engine.onXRSessionStart.add(enterVR);
        props.comp.engine.onXRSessionEnd.add(exitVR);
        return () => {
            props.comp.engine.onXRSessionStart.remove(enterVR);
            props.comp.engine.onXRSessionEnd.remove(exitVR);
        };
    }, []);

    // TK: Remove before release
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                startGame();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const theme = {
        colors: {
            background: '#00000000',
            text: '#d3c8ad',
            primary: '#ffffff',
            secondary: '#ffffff',
            accent: '#ffffff',
        },
    };

    useEffect(() => {
        GameFlowController.instance.ready();
    }, []);

    return (
        <MaterialContext.Provider value={props.comp}>
            <ThemeContext.Provider value={theme}>
                <Container
                    left="-50%"
                    top="-50%"
                    alignItems={Align.Center}
                    justifyContent={Justify.Center}
                >
                    <Container
                        width={50}
                        padding={5}
                        alignItems={Align.Center}
                        justifyContent={Justify.Center}
                    >
                        <Column
                            alignItems={Align.Center}
                            alignContent={Align.Center}
                            justifyContent={Justify.Center}
                        >
                            <Row width={150} alignItems={Align.FlexEnd}>
                                <Text width={40} fontSize={50} text="D"></Text>
                                <Text
                                    fontSize={30}
                                    marginBottom={10}
                                    text="olly's"
                                ></Text>
                            </Row>
                            <Row
                                marginTop={-15}
                                width={120}
                                alignItems={Align.FlexEnd}
                            >
                                <Text width={40} fontSize={50} text="H"></Text>
                                <Text
                                    fontSize={30}
                                    marginBottom={8}
                                    text="ouse"
                                ></Text>
                            </Row>
                            {isVRSupported ? (
                                isInVR ? (
                                    <Button
                                        border={0}
                                        width={50}
                                        height={18}
                                        padding={5}
                                        rounding={2}
                                        hovered={{}}
                                        active={{}}
                                        justifyContent={Justify.Center}
                                        alignContent={Align.Center}
                                        backgroundColor={'#53482d'}
                                        onClick={startGame}
                                    >
                                        <Text
                                            z={0.01}
                                            fontSize={10}
                                            textAlign="center"
                                            text="Start"
                                        ></Text>
                                    </Button>
                                ) : (
                                    <Container></Container>
                                )
                            ) : (
                                <Text fontSize={10} textAlign="center">
                                    Game Requires VR
                                </Text>
                            )}
                        </Column>
                    </Container>
                </Container>
            </ThemeContext.Provider>
        </MaterialContext.Provider>
    );
};

export class MainMenu extends ReactUiBase {
    static TypeName = 'ui:main-menu';
    static InheritProperties = true;

    onActivate(): void {
        super.onActivate();
    }

    override async start(): Promise<void> {
        super.start();
    }

    override update(dt: number) {
        super.update(dt);
    }

    render() {
        return <MainMenuComponent comp={this} />;
    }
}
